import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NotFoundComponent} from './views/routes/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '404',
    pathMatch: 'full',
  },
  {
    path: 'organizer',
    loadChildren: () => import('./views/routes/organizer/organizer.module').then(m => m.OrganizerModule)
  },
  {
    path: 'premium-apply',
    loadChildren: () => import('./views/routes/premium-apply/premium-apply.module').then(m => m.PremiumApplyModule)
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  {
    path: ':eventId',
    children: [
      {
        path: 'ranking/:cognitoId',
        loadChildren: () => import('./views/routes/ouen-ranking/ouen-ranking.module').then(m => m.OuenRankingModule)
      },
      {
        path: 'runnet-campaign-result',
        loadChildren: () => import('./views/routes/runnet-campaign-result/runnet-campaign-result.module').then(m => m.RunnetCampaignResultModule)
      },
      {
        path: 'ouen-campaign',
        loadChildren: () => import('./views/routes/ouen-campaign/ouen-campaign.module').then(m => m.OuenCampaignModule)
      },
      {
        path: '',
        loadChildren: () => import('./views/routes/heatmap/heatmap.module').then(m => m.HeatmapModule)
      },
    ],
  },
  {
    path: '**',
    redirectTo: '404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {paramsInheritanceStrategy: 'always'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
